/**
 * Phase 3 - Hebrew translations module
 */
import enBase from './en.js';
import { translationsHe } from '../../utils/translations/translations.he.js';
import { plansTranslationsHe } from '../../utils/translations/plans/plansTranslations.he.js';

const merged = { ...enBase, ...translationsHe, ...plansTranslationsHe };
export default merged;
